<img
  [attr.width]="size()"
  [attr.height]="size()"
  [attr.src]="src()"
  class="absolute left-0 right-0 top-0 bottom-0 m-auto cursor-pointer"
  alt="Flèche de lecture vidéo"
  loading="lazy"
/>
